import React from 'react'
import { Typogaphy } from 'vnetwork-ui'

interface AssignmentProps {
    message: {
        type: string
        text?: string
        assignedTo?: string
        [key: string]: any
    }
}

const Assignment: React.FC<AssignmentProps> = ({ message }) => {
    return (
        <div className="flex justify-center my-3">
            <div className="bg-blue-50 border border-blue-200 rounded-lg px-4 py-2 max-w-md">
                <div className="flex items-center gap-2">
                    <svg
                        className="w-4 h-4 text-blue-600 flex-shrink-0"
                        fill="none"
                        stroke="currentColor"
                        viewBox="0 0 24 24"
                    >
                        <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            strokeWidth={1}
                            d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z"
                        />
                    </svg>
                    <Typogaphy className="text-xs text-blue-800">
                        Đã gán cho {message?.assignedTo || 'nhân viên'}
                    </Typogaphy>
                </div>
            </div>
        </div>
    )
}

export default Assignment
